import { render, staticRenderFns } from "./doblepie.vue?vue&type=template&id=818fddee"
import script from "./doblepie.vue?vue&type=script&lang=js"
export * from "./doblepie.vue?vue&type=script&lang=js"
import style0 from "./doblepie.vue?vue&type=style&index=0&id=818fddee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports